import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Accounts.css";

const AddAccount = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: "",
        apiKey: "",
        apiSecret: "",
        isGlobal: false,
        isTestnet: false,
    });
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSaving(true);
        axios
            .post("/account/create", formData)
            .then((response) => {
                setSaving(false);
                navigate("/accounts");
            })
            .catch((err) => {
                console.error("Failed to create account:", err);
                setError("Failed to create account.");
                setSaving(false);
            });
    };

    return (
        <div className="edit-account-container">
            <h1>Add New Account</h1>
            {error && <div className="error-message">{error}</div>}
            <form onSubmit={handleSubmit} className="edit-account-form">
                <div className="form-group">
                    <label htmlFor="name">Account Name</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="apiKey">API Key</label>
                    <input
                        type="password"
                        id="apiKey"
                        name="apiKey"
                        value={formData.apiKey}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="apiSecret">API Secret</label>
                    <input
                        type="password"
                        id="apiSecret"
                        name="apiSecret"
                        value={formData.apiSecret}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group checkbox-group">
                    <label htmlFor="isGlobal">Global Account</label>
                    <input
                        type="checkbox"
                        id="isGlobal"
                        name="isGlobal"
                        checked={formData.isGlobal}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-group checkbox-group">
                    <label htmlFor="isTestnet">Testnet</label>
                    <input
                        type="checkbox"
                        id="isTestnet"
                        name="isTestnet"
                        checked={formData.isTestnet}
                        onChange={handleChange}
                    />
                </div>
                <button type="submit" className="save-account-button" disabled={saving}>
                    {saving ? "Saving..." : "Add Account"}
                </button>
            </form>
        </div>
    );
};

export default AddAccount;
